const ADMIN_TYPES={
  START_FETCHING_ALL_PASSENGER_ADMIN: 'START_FETCHING_ALL_PASSENGER_ADMIN',
  SUCCESS_FETCHING_ALL_PASSENGER_ADMIN: 'SUCCESS_FETCHING_ALL_PASSENGER_ADMIN',
  FAILURE_FETCHING_ALL_PASSENGER_ADMIN: 'FAILURE_FETCHING_ALL_PASSENGER_ADMIN',
  START_DELETE_PASSENGER_ADMIN: 'START_DELETE_PASSENGER_ADMIN',
  SUCCESS_DELETE_PASSENGER_ADMIN: 'SUCCESS_DELETE_PASSENGER_ADMIN',
  FAILURE_DELETE_PASSENGER_ADMIN: 'FAILURE_DELETE_PASSENGER_ADMIN',
  ADD_PASSENGER_START: 'ADD_PASSENGER_START',
  ADD_PASSENGER_SUCCESS: 'ADD_PASSENGER_SUCCESS',
  ADD_PASSENGER_FAILURE: 'ADD_PASSENGER_FAILURE',
}

export default ADMIN_TYPES;